export default __webpack_public_path__ + "2aa4481c044531500514ed4259f17e90.png";